import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function LoginPromptDialog({ open, onOpenChange, redirectTo }) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="login-prompt-dialog">
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-praroha-sage/10 flex items-center justify-center">
            <LogIn className="w-6 h-6 text-praroha-sage" />
          </div>
          <DialogTitle className="font-heading text-xl text-praroha-forest">
            Login Required
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Please login to your account to add items to your cart and place orders.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 mt-2">
          <Button
            variant="outline"
            className="flex-1 rounded-full border-praroha-forest/30 text-praroha-forest hover:bg-praroha-forest/5"
            onClick={() => onOpenChange(false)}
            data-testid="login-prompt-cancel"
          >
            Cancel
          </Button>
          <Button
            className="flex-1 rounded-full bg-praroha-forest hover:bg-praroha-forest/90 text-white"
            onClick={() => {
              onOpenChange(false);
              const redirect = redirectTo || window.location.pathname;
              navigate(`/login?redirect=${encodeURIComponent(redirect)}`);
            }}
            data-testid="login-prompt-login"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Login
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
